// extracted by mini-css-extract-plugin
export var askAiIcon = "_p6-9";
export var container = "_p6-0";
export var groupSeparator = "_p6-a";
export var highlight = "_p6-4";
export var resultIcon = "_p6-5";
export var resultItem = "_p6-7";
export var resultSubtitle = "_p6-3";
export var resultTitle = "_p6-2";
export var resultsList = "_p6-1";
export var searchGroup = "_p6-6";
export var selected = "_p6-8";